import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { gql, useMutation } from '@apollo/client';
import { toast } from 'sonner';

const CONFIRM_MANUAL_PAYMENT = gql`
   mutation ReviewPaymentProof($oopId: ID!, $status: String!, $notes: String) {
      reviewPaymentProof(oopId: $oopId, status: $status, notes: $notes) {
         _id
         OOPstatus
      }
   }
`;

const ManualPaymentConfirmDialog = ({ isOpen, onClose, oop, onConfirm }) => {
   const [confirmPayment, { loading }] = useMutation(CONFIRM_MANUAL_PAYMENT, {
      onCompleted: (data) => {
         if (data.reviewPaymentProof) {
            toast.success('Payment confirmed successfully');
            onConfirm?.();
            onClose();
         }
      },
      onError: (error) => {
         toast.error(`Failed to confirm payment: ${error.message}`);
      }
   });

   const handleConfirm = async () => {
      try {
         await confirmPayment({
            variables: {
               oopId: oop._id,
               status: 'APPROVED',
               notes: 'Manual payment confirmed by Bill Collector'
            }
         });
      } catch (error) {
         console.error('Error confirming payment:', error);
      }
   };

   return (
      <Dialog open={isOpen} onOpenChange={onClose}>
         <DialogContent className="bg-white dark:bg-black border dark:border-gray-800">
            <DialogHeader>
               <DialogTitle className="text-gray-900 dark:text-gray-100">
                  Confirm Manual Payment
               </DialogTitle>
               <DialogDescription className="text-gray-500 dark:text-gray-400">
                  Are you sure you want to confirm that this payment has been received?
               </DialogDescription>
            </DialogHeader>

            <div className="space-y-4">
               <div className="bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg border border-gray-100 dark:border-gray-700">
                  <h3 className="font-medium text-gray-900 dark:text-gray-100 mb-2">Payment Details</h3>
                  <div className="grid grid-cols-2 gap-2 text-sm">
                     <div>
                        <span className="text-gray-500 dark:text-gray-400">Bill Number:</span>
                        <p className="text-gray-900 dark:text-gray-200">{oop.billNo}</p>
                     </div>
                     <div>
                        <span className="text-gray-500 dark:text-gray-400">Amount:</span>
                        <p className="text-gray-900 dark:text-gray-200">₱{oop.totalAmount.toFixed(2)}</p>
                     </div>
                     <div>
                        <span className="text-gray-500 dark:text-gray-400">Payee:</span>
                        <p className="text-gray-900 dark:text-gray-200">{oop.namePayee}</p>
                     </div>
                  </div>
               </div>

               <div className="flex justify-end gap-2">
                  <Button
                     variant="outline"
                     onClick={onClose}
                     className="dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
                  >
                     Cancel
                  </Button>
                  <Button
                     onClick={handleConfirm}
                     disabled={loading}
                     className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white
                        dark:from-green-500 dark:to-green-600 dark:hover:from-green-600 dark:hover:to-green-700
                        disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                     {loading ? 'Confirming...' : 'Confirm Payment'}
                  </Button>
               </div>
            </div>
         </DialogContent>
      </Dialog>
   );
};

export default ManualPaymentConfirmDialog;
